module.exports = __webpack_public_path__ + "static/offline-2fc50b9b69373382925d5cda8c544ee6.png";